import * as React from "react";
import { useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AppStandardButton } from "../AppButtons";
import { useTranslation } from "react-i18next";

export function AlertDialog({ open, onClose, onCancel, onConfirm, title }) {
  const { t: translate } = useTranslation();
  const confirmButtonRef = useRef<HTMLDivElement>(null);

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableRestoreFocus
        sx={{
          "& .MuiDialog-container": {
            alignItems: "center",
            justifyContent: "center",
          },
          "& .MuiDialog-paper": {
            margin: "auto",
          },
        }}
        TransitionProps={{
          onEntered: () => {
            const btn = confirmButtonRef.current?.querySelector("button");
            btn?.focus();
          },
        }}
      >
        <DialogTitle>{title}</DialogTitle>

        <DialogActions>
          <AppStandardButton variant="outlined" onClick={onCancel}>
            <p className="text-black normal-case">{translate("Close1")}</p>
          </AppStandardButton>
          <div ref={confirmButtonRef}>
            <AppStandardButton onClick={onConfirm}>
              <p className="normal-case">{translate("Add Driver")}</p>
            </AppStandardButton>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
